<script>
    // Stores
    import { alt, linkAV } from '../store.js';

    export let href     = $linkAV + "/login?boleto-facil=1";
    export let title    = "Peça aqui seu Boleto Fácil " + $alt;
    export let image    = "imgBoleto.png"
</script>

<span class="boletoFacil">
	<a {href} target="_blank" {title}>
		<img src="/images/{image}" alt="Ícone Boleto Fácil {$alt}" {title} />
	</a>
</span>

<style type="text/sass">
.boletoFacil
    display: inline-block
    position: fixed
    left: 5px
    z-index: 100 
    bottom: 5px 
    img
        border: 0
</style>